import img_1 from "../assets/img/geschiedenis/de_harp_oud.jpg";
import img_2 from "../assets/img/geschiedenis/de_harp_1973.jpg";
import img_3 from "../assets/img/geschiedenis/de schuif.jpg";
import img_4 from "../assets/img/geschiedenis/groepsfoto_recent.jpg";
import Landing from "../views/Landing";

function Geschiedenis() {
  return (
    <>
      <Landing title={"90 jaar DE HARP"} />
      <div className="content_container">
        <div className="geschiedenis__container responsive_width">
          <div className="center">
            <h3 className="responsive_width geschiedenis_title">
              {/* 90 jaar DE HARP */}
            </h3>
          </div>
          {/* <div className="geschiedenis__row"></div> */}
          <div className="geschiedenis__row">
            Het verhaal van Harpe Davids, waarvoor we 90 jaar terug in de tijd
            gaan, is een verhaal dat het samenspel tussen muziek, vriendschap en
            geschiedenis weerspiegelt. Reis met ons mee door de tijd en verken
            de hoogtepunten van de Harp van de afgelopen negen decennia.
          </div>
          <div className="geschiedenis__row">
            <h2>De oprichting</h2>
            Vanuit de gereformeerde gemeenschap ontstond in 1932 het initiatief
            om een eigen muziekkorps op te richten. De initiatiefnemer was
            hoofdopzichter bij de staatsmijn Emma. De belangstelling was groot.
            En op 15 oktober 1933 werd officieel Fanfare Harpe Davids opgericht.{" "}
            <br /> <br />
            De contributie van de leden werd vastgesteld op een kwartje per
            week. Als muzikale leider werd de op muziekgebied toen al zeer
            deskundige heer P. Stalmeier aangetrokken. De heer W. Stoffer
            vervulde de functie van voorzitter. Al spoedig kon worden overgegaan
            tot de aanschaf van een complete fanfarebezetting, bestaande uit
            ongeveer 30 instrumenten. De prijs voor dit instrumentarium was
            zestienhonderd gulden, een bedrag waar we nu nog niet één saxofoon
            voor kopen.
          </div>

          <div className="geschiedenis__row">
            <h2>Eerste successen</h2>
            Na een succesvol eerste concours in 1935 ontving de fanfare als
            blijk van waardering een prachtig vaandel. Een donkergroen vaandel,
            met een gouden lauwerkrans en een mijnlamp erbovenop. De financiële
            middelen werden inmiddels iets ruimer, waardoor er ook uniformpetten
            konden worden aangeschaft. <br /> <br />
            Onder leiding van de heer Stalmeier bleven de successen elkaar
            opvolgen. Er werden eerste prijzen gehaald op verschillende
            concoursen. Vanaf de oprichting van "Harpe Davids" tot het uitbreken
            van de oorlog verleende het korps steeds muzikale medewerking aan de
            Oranjefeesten en schoolfeesten in Treebeek. Ook werden serenades
            gebracht bij huwelijken en jubilea. Tijdens de oorlog waren er geen
            activiteiten.
          </div>
          <img className="geschiedenis_image" src={img_1} alt="demo"></img>
          <div className="geschiedenis__row">
            <h2>Na-oorlogse jaren</h2>
            Na de oorlog, in 1945, begon de wederopbouw onder de muzikale
            leiding van de heer W. Boersma. Het ledental kwam langzamerhand weer
            op peil en ook het muzikale peil vertoonde een stijgende lijn. In de
            daaropvolgende jaren nam de fanfare deel aan een aantal
            bondsconcoursen, het korps kwam meermaals naar huis met een eerste
            prijs. In 1955 kon men overgaan tot de aanschaf van een compleet
            nieuw instrumentarium. Desondanks kreeg de fanfare te maken met veel
            ledenverloop en vonden er enkele dirigentenwisselingen plaats.
          </div>
          <div className="geschiedenis__row">
            <h2>Eerste uniformen</h2>
            Om met de tijd mee te gaan was het wenselijk om de uniformpet te
            vervangen door een compleet uniform. De in het leven geroepen
            uniformencommissie organiseerde in 1960 de uniformering van de
            fanfare en de in die tijd opgerichte drumband.
            <br />
            <br />
            In 1973 werd op bescheiden wijze het 40-jarig jubileum gevierd in
            het nieuwe Casino van Treebeek. In 1983 volgde het 50-jarig
            jubileum. Hiervoor werd een gedurfde loterij opgezet. De loten
            gingen van de hand voor maar liefst 100 gulden per stuk. De actie
            bleek een succes en op 13 oktober werd het beoogde doel bereikt: de
            presentatie van de nieuwe uniformen. Ook werd ter gelegenheid van
            dit gouden jubileum een tegel vervaardigd met de afbeelding van het
            vaandel.
          </div>
          <img className="geschiedenis_image" src={img_2} alt="demo"></img>
          <div className="geschiedenis__row">
            <h2>De jaren '90</h2>
            In 1993 vierde de fanfare het 60-jarig bestaan. Het bestuur kwam met
            het idee de 'Harpdag' in het leven te roepen: Nederlandse
            muziekkorpsen die de naam Harpe Davids dragen, werden uitgenodigd
            voor een bijzondere muzikale dag. Er kwamen korpsen uit Ridderkerk,
            Zoetermeer, Noordwijkerhout en Schiedam. Op 9 oktober was er in het
            centrum van Brunssum een optocht met de vijf Harpe Davidsen. Later
            die dag concerteerden de ruim 400 muzikanten. Ter gelegenheid van
            het 60-jarig jubileum werd een glas in lood herdenkingsgeschenk
            gemaakt. Dit is (samen met de gouden jubileumtegel) te zien in de
            vaandelkast. Het initiatief van de ‘Harpdag’ werd opgepikt door de
            andere 'Harpen' en er volgde een bezoek aan Harpe Davids Zoetermeer
            in september 1994, Harpe Davids Ridderkerk in mei 1995 en de
            vereniging uit Schiedam in september 2007.
            <br />
            <br />
            In 1995 leverde zowel de fanfare als de drumband een zeer grote
            muzikale prestatie tijdens een bondsconcours. Dit was reden om
            toenmalig dirigent Henk Houben na zijn afscheid tot eredirigent te
            benoemen.
            <br />
            <br />
            Na decennia thuis te zijn geweest in de Kruiskerk aan de Ds.
            Boumastraat, vond de Harp in 1998 haar volgende onderkomen in de
            nieuwe Pelgrimskerk. De openingsdienst op 19 december werd door de
            fanfare opgeluisterd. Na intensief overleg met het College van
            Kerkrentmeesters kreeg Harpe Davids toestemming het repetitielokaal
            te verrijken met een buffet (de bar), dat in maart 1999 werd
            geopend.
            <br />
            <br />
            De opbloei van Harpe Davids in de jaren '90 uitte zich ook op
            niet-muzikaal gebied. Naast de reeds succesvolle wandelclub WKHD
            (Wandelkomitee Harpe Davids) startte ook de fanfare-ondersteunende
            FF-club in 1993 een jaarlijks terugkerend evenement: de
            Cadeautjesmarkt.
          </div>
          <img className="geschiedenis_image" src={img_3} alt="demo"></img>
          <div className="geschiedenis__row">
            <h2>Het nieuwe millennium</h2>
            Voortgaand op het succes daarvan werd in 1997 het initiatief genomen
            om het Uniformenfonds te starten. Dit resulteerde eind 2002 in
            nieuwe uniformering. In die gloriejaren was ook het verenigingsblad
            De Schuif jarenlang een begrip.
            <br />
            <br />
            In 2000 nam de toen piepjonge Ron Daelemans het (figuurlijke)
            dirigeerstokje over van Henk Houben en 2002 gaf Johan Pastoor de
            voorzittershamer door aan Maurits van der Werff. De heer Pastoor
            werd de vierde erevoorzitter. Onder leiding van dit jonge, maar
            sterke duo sloeg de fanfare een nieuwe weg in. Dat begon met een
            eerste Gala-concert in 2002. Hierna volgden nog vele muzikale
            avonturen, zoals concertreizen, Harp Royal, rockconcerten en
            bijzondere uitvoeringen zoals de medewerking aan de voorstelling
            Emma in de Emma schoenfabriek tijdens Cultura Nova en de opening van
            de Buitenring Parkstad Limburg. Het repertoire verandert in een mix
            van traditioneel en modern.
          </div>
          <img className="geschiedenis_image" src={img_4} alt="demo"></img>
          <br />
          <br />
          <div className="geschiedenis__row">
            In 2013 werd de club van 50 opgericht. Dankzij de jaarlijkse
            bijdrage van 50 euro per trouwe donateur is het mogelijk om meer te
            investeren in onder andere nieuwe instrumenten.
            <br />
            <br />
            In 2023 viert Harpe Davids haar 90-jarig bestaan. Er werden
            verschillende werkgroepen gevormd om dit jubileum te vieren. Het
            eerste vaandel uit 1935 hangt inmiddels weer in ons vertrouwde
            repetitielokaal in Treebeek. Tijdens het jubileumconcert op 14
            oktober 2023 werden de muzikale hoogtepunten uit de afgelopen 9
            decennia opnieuw beleefd. En op 15 oktober werd de 90e verjaardag op
            feestelijke wijze gevierd.
            <br />
            <br />
            Met een nieuw logo, verfrissende foto’s die zorgen voor een
            eigentijdse uitstraling kijkt deze bruisende vereniging vol trots
            naar de toekomst!
            <br />
            <br />
          </div>
        </div>
      </div>
    </>
  );
}

export default Geschiedenis;
